module.exports = __webpack_public_path__ + "static/img/7.544a971.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/7.png
// module id = q3ue
// module chunks = 0